import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import s from './MLButton.module.css';

function classByType(btnType) {
  if (btnType === 'secondary') return s.btnSecondary;
  if (btnType === 'secondaryRed') return s.btnSecondaryRed;
  if (btnType === 'primary') return s.btnPrimary;
  if (btnType === 'primary-chip') return `${s.btnPrimaryChip} ${s.btnChip}`;
  if (btnType === 'secondary-chip') return `${s.btnSecondaryChip} ${s.btnChip}`;
  return '';
}

function MLButton(props) {
  const {
    id,
    className,
    disabled,
    btnType,
    onClick,
    btnText,
    ariaLabel,
    children,
    testId,
    ariaExpanded,
    customAttributes,
  } = props;
  let mappedAttributes = [];
  if (ariaExpanded !== undefined) {
    mappedAttributes['aria-expanded'] = ariaExpanded;
  }
  if (customAttributes) {
    mappedAttributes = customAttributes.reduce((acc, current) => {
      acc[current.attribute] = current.value;
      return acc;
    }, {});
  }

  return (
    <button
      id={id}
      className={classnames(classByType(btnType), className)}
      disabled={disabled}
      aria-label={ariaLabel || btnText}
      onClick={onClick}
      data-test-id={testId}
      {...mappedAttributes}
    >
      {btnText || children}
    </button>
  );
}

MLButton.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  btnType: PropTypes.string,
  onClick: PropTypes.func,
  btnText: PropTypes.string,
  ariaLabel: PropTypes.string,
  children: PropTypes.any,
  testId: PropTypes.string,
  ariaExpanded: PropTypes.bool,
  customAttributes: PropTypes.arrayOf(
    PropTypes.shape({
      attribute: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
  ),
};

export default MLButton;
